// ═══ MÓDULOS E PERMISSÕES ═══
// Uma linha por módulo. "proprio" = só o que é seu; "todos" = de toda a gente.
// Onde a distinção não faz sentido, temProprio é false.
export const MODULOS = [
  { id:'projetos',      nome:'Projetos',                      grupo:'Operações',  temProprio:true  },
  { id:'comissoes',     nome:'Projetos — comissões',          grupo:'Operações',  temProprio:false, filho:true },
  { id:'calendario',    nome:'Calendário',                    grupo:'Operações',  temProprio:false },
  { id:'rede',          nome:'Rede de profissionais',         grupo:'Operações',  temProprio:false },
  { id:'contas',        nome:'Contas / Clientes',             grupo:'Contas',     temProprio:false },
  { id:'finClientes',   nome:'Por Cliente',                   grupo:'Financeiro', temProprio:false },
  { id:'finProfs',      nome:'Por Profissional',              grupo:'Financeiro', temProprio:false },
  { id:'tesouraria',    nome:'Tesouraria',                    grupo:'Financeiro', temProprio:false },
  { id:'comercial',     nome:'Comercial',                     grupo:'Comercial & Marketing', temProprio:true  },
  { id:'marketing',     nome:'Marketing',                     grupo:'Comercial & Marketing', temProprio:false },
  { id:'presencas',     nome:'Presenças',                     grupo:'Pessoas',    temProprio:true  },
  { id:'bancoHoras',    nome:'Banco de horas',                grupo:'Pessoas',    temProprio:true  },
  { id:'rhJustificacoes', nome:'RH — Justificações e documentos', grupo:'Pessoas', temProprio:true, temEquipa:true },
  { id:'rhContratos',   nome:'RH — Contratos',                grupo:'Pessoas',    temProprio:true, temEquipa:true },
  { id:'rhAvaliacoes',  nome:'RH — Avaliações de desempenho', grupo:'Pessoas',    temProprio:true, temEquipa:true },
  { id:'utilizadores',  nome:'Utilizadores',                  grupo:'Pessoas',    temProprio:false },
  { id:'biblioteca',    nome:'Biblioteca',                    grupo:'Recursos',   temProprio:false },
  { id:'definicoes',    nome:'Definições',                    grupo:'Recursos',   temProprio:false },
];

// O que cada perfil pode, por defeito. v=ver todos, t=ver a sua equipa, p=ver só o próprio, e=editar (dentro do que vê)
export const PERFIS_BASE = {
  admin: {
    projetos:{v:1,e:1}, comissoes:{v:1,e:1}, calendario:{v:1,e:1},
    finClientes:{v:1,e:1}, finProfs:{v:1,e:1}, tesouraria:{v:1,e:1},
    comercial:{v:1,e:1}, marketing:{v:1,e:1}, contas:{v:1,e:1}, rede:{v:1,e:1},
    biblioteca:{v:1,e:1}, presencas:{v:1,e:1}, bancoHoras:{v:1,e:1}, rhJustificacoes:{v:1,e:1}, rhContratos:{v:1,e:1}, rhAvaliacoes:{v:1,e:1}, utilizadores:{v:1,e:1}, definicoes:{v:1,e:1},
  },
  tl: {
    projetos:{v:1,e:1}, comissoes:{}, calendario:{v:1,e:1},
    finClientes:{v:1}, finProfs:{v:1}, tesouraria:{},
    comercial:{}, marketing:{}, contas:{v:1,e:1}, rede:{v:1},
    biblioteca:{v:1}, presencas:{v:1}, bancoHoras:{v:1}, rhJustificacoes:{p:1,t:1,e:1}, rhContratos:{p:1}, rhAvaliacoes:{p:1,t:1}, utilizadores:{}, definicoes:{},
  },
  financial: {
    projetos:{v:1}, comissoes:{v:1}, calendario:{v:1},
    finClientes:{v:1,e:1}, finProfs:{v:1,e:1}, tesouraria:{v:1,e:1},
    comercial:{v:1}, marketing:{}, contas:{v:1}, rede:{v:1},
    biblioteca:{v:1}, presencas:{v:1}, bancoHoras:{v:1,e:1}, rhJustificacoes:{p:1,e:1}, rhContratos:{p:1}, rhAvaliacoes:{p:1}, utilizadores:{}, definicoes:{},
  },
  comercial: {
    projetos:{v:1,e:1}, comissoes:{v:1,e:1}, calendario:{v:1},
    finClientes:{v:1}, finProfs:{}, tesouraria:{},
    comercial:{p:1,e:1}, marketing:{v:1,e:1}, contas:{v:1,e:1}, rede:{v:1},
    biblioteca:{v:1}, presencas:{p:1}, bancoHoras:{p:1,e:1}, rhJustificacoes:{p:1,e:1}, rhContratos:{p:1}, rhAvaliacoes:{p:1}, utilizadores:{}, definicoes:{},
  },
  operations: {
    projetos:{v:1,e:1}, comissoes:{}, calendario:{v:1,e:1},
    finClientes:{}, finProfs:{v:1,e:1}, tesouraria:{},
    comercial:{}, marketing:{}, contas:{v:1,e:1}, rede:{v:1,e:1},
    biblioteca:{v:1}, presencas:{p:1}, bancoHoras:{p:1,e:1}, rhJustificacoes:{p:1,e:1}, rhContratos:{p:1}, rhAvaliacoes:{p:1}, utilizadores:{}, definicoes:{},
  },
};

// Junta o perfil com as exceções da pessoa.
export function permissoesDe(role, excecoes) {
  const base = PERFIS_BASE[role] || PERFIS_BASE.operations;
  const out = {};
  MODULOS.forEach(m => {
    const b = base[m.id] || {};
    const ex = (excecoes && excecoes[m.id]) || {};
    out[m.id] = {
      v: ex.v !== undefined ? !!ex.v : !!b.v,
      p: ex.p !== undefined ? !!ex.p : !!b.p,
      t: ex.t !== undefined ? !!ex.t : !!b.t,
      e: ex.e !== undefined ? !!ex.e : !!b.e,
    };
  });
  return out;
}

// Só o que DIFERE do perfil é guardado — assim mudar o perfil continua a
// mexer em toda a gente, exceto onde houve uma decisão explícita.
export function apenasExcecoes(role, permissoes) {
  const base = PERFIS_BASE[role] || PERFIS_BASE.operations;
  const out = {};
  MODULOS.forEach(m => {
    const b = base[m.id] || {};
    const p = permissoes[m.id] || {};
    const d = {};
    if (!!p.v !== !!b.v) d.v = !!p.v;
    if (!!p.p !== !!b.p) d.p = !!p.p;
    if (!!p.t !== !!b.t) d.t = !!p.t;
    if (!!p.e !== !!b.e) d.e = !!p.e;
    if (Object.keys(d).length) out[m.id] = d;
  });
  return out;
}
